import { render } from "./PaymentBridge.vue?vue&type=template&id=2279d09d&ts=true"
import script from "./PaymentBridge.vue?vue&type=script&lang=ts"
export * from "./PaymentBridge.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__